export enum UserType {
  PROVIDER = "PROVIDER",
  PATIENT = "PATIENT",
  ASSISTANT = "ASSISTANT",
}

export enum PatientStatus {
  NEW = "NEW",
  EXISTING = "EXISTING",
  RETURNING = "RETURNING", // Patient has appointments but before the days_until_patient_becomes_new cutoff date
}
